export default __webpack_public_path__ + "static/bg-pttrn-3bb01a390641d2623a1cd1254672e4ac.png";